<template>
  <!-- 客户案例 -->
  <div class="customer-case-container">
    <div class="customer-case-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/customer-case-banner.png"
        alt=""
      />
      <p class="banner-p">客户案例</p>
    </div>
    <div class="customer-case-container-content">
      <ul class="customer-case-container-content-list">
        <li v-for="(item, i) in customList" :key="i">
          <img :src="item.pic" alt="" />
          <div class="customer-case-container-content-list-mask">
            {{ item.title }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item1.png",
          title: "湖北省图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item2.png",
          title: "武汉市图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item3.png",
          title: "洪山区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item4.png",
          title: "硚口区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item5.png",
          title: "青山区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item6.png",
          title: "江汉区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item7.png",
          title: "青山区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item8.png",
          title: "武昌区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item9.png",
          title: "江岸区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item10.png",
          title: "江夏区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item11.png",
          title: "东西湖区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item12.png",
          title: "黄石市图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item13.png",
          title: "黄石港区图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item14.png",
          title: "宜昌市图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item15.png",
          title: "孝感市图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item16.png",
          title: "随州市图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item17.png",
          title: "华中科技大学图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item18.png",
          title: "中国地质大学图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item19.png",
          title: "中南财经政法大学图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item20.png",
          title: "中南民族大学图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item21.png",
          title: "武汉科技大学图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item22.png",
          title: "武汉东湖学院图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item23.png",
          title: "武汉城市职业学院图书馆",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/customerCase/case-index-item24.png",
          title: "广西师范大学图书馆",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/customer-case.scss";
</style>
